export default class Select {
    constructor(el, parentEl = null) {
        if (!this.set(el, parentEl)) return;
        this.init();
    }

    set(el, parentEl) {
        if (!el) return false;
        this.root = el;
        this.parent = parentEl;
        this.current = this.root.querySelector('[data-select-current]');
        this.currentText = this.root.querySelector(
            '[data-select-current-text]'
        );
        this.select = this.root.querySelector('[data-select-select]');
        this.items = this.root.querySelectorAll('[data-select-item]');

        this.value = null;

        return true;
    }

    init() {
        this.initSelect();
        this.bind();
    }

    initSelect() {
        if (!this.select || !this.items) return;
        const value = this.items[0].getAttribute(['data-select-item-value']);
        const label = this.items[0].getAttribute(['data-select-item-label']);


        this.select.value = value;
        this.setCurrentText(label);
        this.setCurrentItem(this.items[0]);
    }

    bind() {
        this.bindCurrent();
        this.bindItems();
    }

    bindCurrent() {
        if (!this.current) return;

        this.onCurrentClick = this.onCurrent.bind(this);
        this.current.addEventListener('click', this.onCurrentClick);
    }

    bindItems() {
        if (!this.items) return;
        this.onItemClick = this.onItem.bind(this);

        this.items.forEach(item => {
            item.addEventListener('click', event => this.onItem(event));
        });
    }

    onCurrent() {
        this.root.classList.toggle('active');
    }

    onItem(event) {
        if (!this.select) return;

        const { currentTarget } = event;
        const value = currentTarget.getAttribute('data-select-item-value');
        const label = currentTarget.getAttribute('data-select-item-label');

        this.select.value = value;
        this.root.classList.remove('active');
        this.setCurrentText(label);
        this.resetItems();
        this.setCurrentItem(currentTarget);

        if (this.parent) {
            const event = new CustomEvent('custom-select-change', {
                detail: value,
            });

            this.parent.dispatchEvent(event);
        }
    }

    setCurrentText(text) {
        if (!text || !this.currentText) return;
        this.currentText.innerHTML = text;
    }

    resetItems() {
        if (!this.items) return;
        this.items.forEach(item => {
            item.classList.remove('active');
        });
    }

    setCurrentItem(item) {
        item.classList.add('active');
    }
}
